import React from 'react'

export default function ComponentIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_522_2370)">
        <path
          d="M3.96916 5.45866L6.01082 7.50033L3.96916 9.54199L1.92749 7.50033L3.96916 5.45866Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.76082 1.66699L9.80249 3.70866L7.76082 5.75033L5.71916 3.70866L7.76082 1.66699Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5525 5.45866L13.5942 7.50033L11.5525 9.54199L9.51082 7.50033L11.5525 5.45866Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.76082 9.25033L9.80249 11.292L7.76082 13.3337L5.71916 11.292L7.76082 9.25033Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2370">
          <rect width="14" height="14" fill="white" transform="translate(0.760864 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
